<script setup>

import {ref} from "vue";

const state = ref('')
const createdApiKey = ref(null)
const create = async () => {
    createdApiKey.value = null
    state.value = 'waiting'

    const res = await axios.post(route('api.user.apiKey'))

    createdApiKey.value = res.data.plainTextToken
    state.value = 'success'
}
</script>
<template>
    <div>
        <div
            v-if="createdApiKey"
            class="border rounded-wl p-4"
        >
            <p>
                Here is your new API key. Make sure to copy it now, as you won't be able to see it again.
            </p>
            <code class="select-all bg-gray-50">
                {{ createdApiKey }}
            </code>
        </div>

        <div class="mt-4">
            <button-secondary @click="create">
                {{ _mft('user:apiKeys.createApiKey') }}
            </button-secondary>
        </div>
    </div>
</template>
